export class JobLinks {
  constructor(
    public urlJobSite = '',
    public urlJobApplication = ''
  ) {}
}
